<template>
  <div
    class="modal fade"
    id="modalEliminarResultados"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalEliminarResultadosLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content border-0 shadow-lg rounded-lg">
        <!-- Header -->
        <div class="modal-header border-0 pb-1 pt-3 px-4">
          <div class="d-flex align-items-center">
            <div
              class="rounded-circle d-flex align-items-center justify-content-center mr-3 bg-danger-soft text-danger"
              style="width: 42px; height: 42px; min-width: 42px;"
            >
              <i class="fas fa-trash-alt fa-lg"></i>
            </div>
            <div>
              <h5 class="modal-title font-weight-bold text-dark mb-0" id="modalEliminarResultadosLabel">
                Anular Resultados de Laboratorio
              </h5>
              <small class="text-muted" v-if="order && (order.orden_trabajo || order.id)">
                Orden #{{ order.orden_trabajo ? order.orden_trabajo.id : order.id }} • {{ examenes.length }} examen(es) seleccionado(s)
              </small>
            </div>
          </div>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Cerrar"
            :disabled="isSubmitting"
            @click="cerrar(true)"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Body con distribución en 2 columnas -->
        <div class="modal-body py-2 px-4">
          <div class="row">
            <!-- Columna Izquierda: Información del Paciente, Muestra y Exámenes -->
            <div class="col-md-6 pr-md-2 mb-3 mb-md-0 d-flex flex-column">
              <!-- Card del Paciente y Muestra -->
              <div class="patient-card p-2 px-3 rounded border mb-2" v-if="order && order.orden_trabajo">
                <div class="d-flex align-items-center mb-2">
                  <div class="avatar-box mr-2">
                    <img
                      v-if="order.orden_trabajo.usuario && order.orden_trabajo.usuario.sexo === 'F'"
                      src="@/assets/img-genero/mujer.png"
                      class="avatar-img"
                      alt="Paciente"
                    />
                    <img
                      v-else-if="order.orden_trabajo.usuario && order.orden_trabajo.usuario.sexo === 'M'"
                      src="@/assets/img-genero/hombre.png"
                      class="avatar-img"
                      alt="Paciente"
                    />
                    <div v-else class="avatar-placeholder">
                      <i class="fas fa-user text-primary"></i>
                    </div>
                  </div>
                  <div class="flex-grow-1 text-truncate">
                    <div class="font-weight-bold text-dark text-truncate" style="font-size: 0.88rem;" v-if="order.orden_trabajo.usuario">
                      {{ order.orden_trabajo.usuario.nombre_1 }} {{ order.orden_trabajo.usuario.nombre_2 || '' }}
                      {{ order.orden_trabajo.usuario.apellido_1 }} {{ order.orden_trabajo.usuario.apellido_2 || '' }}
                    </div>
                    <div class="text-muted small mt-0 d-flex align-items-center flex-wrap" v-if="order.orden_trabajo.usuario">
                      <span class="badge badge-light border text-dark font-weight-normal mr-1 py-0 px-1" style="font-size: 0.72rem;">
                        <strong class="text-primary">{{ order.orden_trabajo.usuario.tipo_documento ? order.orden_trabajo.usuario.tipo_documento.codigo : 'DOC' }}</strong>
                        {{ order.orden_trabajo.usuario.documento }}
                      </span>
                      <span v-if="order.orden_trabajo.usuario.years" class="text-muted" style="font-size: 0.75rem;">
                        {{ order.orden_trabajo.usuario.years }} años
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Muestra y Orden -->
                <div class="d-flex align-items-center justify-content-between pt-1 border-top">
                  <div class="d-flex align-items-center">
                    <span class="text-muted mr-1 font-weight-bold" style="font-size: 0.7rem;">MUESTRA:</span>
                    <span class="badge badge-purple-soft font-weight-bold px-2 py-0" style="font-size: 0.78rem;">
                      <i class="fas fa-flask mr-1"></i>
                      {{ order.orden_trabajo.toma_muestra || 'N/A' }}
                    </span>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="text-muted mr-1 font-weight-bold" style="font-size: 0.7rem;">ORDEN:</span>
                    <span class="badge badge-light border text-dark font-weight-bold px-1 py-0" style="font-size: 0.78rem;">
                      #{{ order.orden_trabajo.id }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Lista de Exámenes a Anular -->
              <div class="exams-container rounded border p-2 bg-light flex-grow-1 d-flex flex-column">
                <div class="d-flex justify-content-between align-items-center px-1 mb-1">
                  <span class="font-weight-bold text-gray-700 text-uppercase" style="letter-spacing: 0.4px; font-size: 0.68rem;">
                    Exámenes a anular ({{ examenes.length }})
                  </span>
                  <span class="badge badge-danger-soft text-danger font-weight-bold" style="font-size: 0.68rem;">
                    Seleccionados
                  </span>
                </div>
                <div class="exams-list flex-grow-1" style="max-height: 140px; min-height: 90px; overflow-y: auto;">
                  <div
                    v-for="detalle in examenes"
                    :key="detalle.id"
                    class="exam-item d-flex justify-content-between align-items-center bg-white px-2 py-1 mb-1 rounded border-sm shadow-2xs"
                  >
                    <div class="d-flex align-items-center text-truncate mr-2">
                      <i class="fas fa-microscope text-primary mr-1" style="font-size: 0.75rem;"></i>
                      <span class="font-weight-semibold text-dark small text-truncate" :title="detalle.examenes ? detalle.examenes.nombre : 'Examen'" style="font-size: 0.8rem;">
                        {{ detalle.examenes ? detalle.examenes.nombre : 'Examen' }}
                      </span>
                    </div>
                    <div class="flex-shrink-0">
                      <span class="badge badge-danger-outline font-weight-bold px-2 py-0" style="font-size: 0.74rem;">
                        <small class="text-muted mr-1 font-weight-normal">Val:</small>
                        {{ detalle.resultado !== undefined && detalle.resultado !== null && detalle.resultado !== '' ? detalle.resultado : 'Sin valor' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Columna Derecha: Advertencia y Justificación / Motivo -->
            <div class="col-md-6 pl-md-2 d-flex flex-column justify-content-between">
              <!-- Alerta de Advertencia -->
              <div class="alert alert-warning-soft border-0 d-flex align-items-start py-2 px-3 mb-2 rounded">
                <i class="fas fa-exclamation-triangle text-warning mr-2 mt-1"></i>
                <div class="small text-dark" style="line-height: 1.3; font-size: 0.82rem;">
                  <strong>Acción irreversible:</strong> Los resultados serán removidos permanentemente del registro actual y esta acción no podrá deshacerse.
                </div>
              </div>

              <!-- Motivo de Anulación -->
              <div class="form-group flex-grow-1 d-flex flex-column mb-0">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <label class="font-weight-bold text-dark small mb-0">
                    Motivo de anulación <span class="text-danger">*</span>
                  </label>
                  <span
                    class="badge badge-pill"
                    :class="!$v.motivo.$invalid && motivo.trim().length >= 10 ? 'badge-success-soft text-success font-weight-bold' : 'badge-light text-muted'"
                    style="font-size: 0.72rem;"
                  >
                    <i :class="!$v.motivo.$invalid && motivo.trim().length >= 10 ? 'fas fa-check-circle mr-1' : 'fas fa-pen mr-1'"></i>
                    {{ motivo.trim().length }}/10 carac. mín.
                  </span>
                </div>

                <textarea
                  class="form-control form-control-sm custom-textarea flex-grow-1"
                  :class="{
                    'is-invalid': $v.motivo.$error && $v.motivo.$dirty,
                    'is-valid': !$v.motivo.$invalid && $v.motivo.$dirty
                  }"
                  style="min-height: 110px;"
                  rows="4"
                  v-model="motivo"
                  placeholder="Indique la justificación clínica o administrativa de la anulación (mínimo 10 caracteres)..."
                  @blur="$v.motivo.$touch()"
                  :disabled="isSubmitting"
                ></textarea>

                <div class="invalid-feedback small" v-if="$v.motivo.$dirty && !$v.motivo.required">
                  El motivo es obligatorio.
                </div>
                <div class="invalid-feedback small" v-else-if="$v.motivo.$dirty && !$v.motivo.noRepetitiveChars">
                  No repita el mismo carácter consecutivamente (ej. xxxxx, .....).
                </div>
                <div class="invalid-feedback small" v-else-if="$v.motivo.$dirty && (!$v.motivo.minLength || !$v.motivo.hasValidText)">
                  Ingrese una justificación válida con palabras reales (mínimo 10 caracteres).
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer border-0 pt-2 pb-3 px-4 d-flex justify-content-between align-items-center">
          <span class="text-muted small">
            <i class="fas fa-info-circle mr-1"></i>
            {{ examenes.length }} resultado(s) a procesar
          </span>
          <div>
            <button
              type="button"
              class="btn btn-light btn-sm text-muted font-weight-bold px-3 mr-2"
              data-dismiss="modal"
              :disabled="isSubmitting"
              @click="cerrar(true)"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger btn-sm font-weight-bold px-4 shadow-sm"
              :disabled="$v.motivo.$invalid || examenes.length === 0 || isSubmitting"
              @click="confirmarEliminar()"
            >
              <span v-if="isSubmitting">
                <i class="fas fa-spinner fa-spin mr-1"></i> Anulando...
              </span>
              <span v-else>
                <i class="fas fa-trash-alt mr-1"></i> Confirmar Anulación ({{ examenes.length }})
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { required, minLength } from "vuelidate/lib/validators";
import Toast from "../../../../../components/common/utilities/toast";
import logDeletedResultService from "../../../../../services/logDeletedResultService";

// Validador: no permitir 4 o más caracteres idénticos consecutivos (ej. xxxxx, ....., -----)
const noRepetitiveChars = (val) => {
  if (!val) return true;
  return !/(.)\1{3,}/i.test(val);
};

// Validador: texto con palabras reales, sin solo espacios o símbolos
const hasValidText = (val) => {
  if (!val) return true;
  const trimmed = val.trim();
  if (trimmed.length < 10) return false;

  // Extraer letras (incluyendo acentos y ñ)
  const letters = trimmed.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ]/g, "");
  // Debe contener al menos 6 letras
  if (letters.length < 6) return false;

  // Debe contener diversidad de caracteres (al menos 4 letras distintas)
  const uniqueLetters = new Set(letters.toLowerCase().split(""));
  return uniqueLetters.size >= 4;
};

export default {
  name: "ModalEliminarResultados",
  data() {
    return {
      order: {},
      examenes: [],
      motivo: "",
      id_sede: null,
      isSubmitting: false,
    };
  },
  validations: {
    motivo: {
      required,
      minLength: minLength(10),
      noRepetitiveChars,
      hasValidText,
    },
  },
  methods: {
    abrir(order, examenesSeleccionados, idSede = null) {
      this.order = order || {};
      this.examenes = examenesSeleccionados ? [...examenesSeleccionados] : [];
      this.id_sede = idSede;
      this.motivo = "";
      this.isSubmitting = false;
      this.$v.$reset();

      $(this.$el).modal({
        backdrop: "static",
        keyboard: false,
        show: true,
      });
    },

    cerrar(fromCancel = false) {
      $(this.$el).modal("hide");
      this.motivo = "";
      this.examenes = [];
      this.order = {};
      this.$v.$reset();
      if (fromCancel) {
        this.$emit("cancelar");
      }
    },

    async confirmarEliminar() {
      this.$v.$touch();
      if (this.$v.$invalid || !this.examenes.length) {
        return;
      }

      try {
        this.isSubmitting = true;

        const payload = {
          resultado_id: this.order.id,
          id_sede: this.id_sede,
          observacion: this.motivo,
          detalles: this.examenes.map((d) => ({
            id: d.id,
            id_examen: d.id_examen || (d.examenes ? d.examenes.id : null),
            valor_anterior:
              d.resultado !== undefined && d.resultado !== null && d.resultado !== ""
                ? String(d.resultado)
                : "Sin resultado",
            motivo: this.motivo,
          })),
        };

        await logDeletedResultService.store(payload);

        Toast.fire({
          icon: "success",
          title: "Resultados anulados con éxito",
        });

        this.$emit("eliminado", {
          orderId: this.order.id,
          detalles: this.examenes,
        });

        this.cerrar(false);
      } catch (error) {
        console.error("Error al anular resultados de laboratorio:", error);
        Toast.fire({
          icon: "error",
          title:
            (error.response && error.response.data && error.response.data.message) ||
            "Ocurrió un error al anular los resultados",
        });
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
.bg-danger-soft {
  background-color: rgba(231, 74, 59, 0.12);
}

.badge-purple-soft {
  background-color: rgba(133, 92, 248, 0.12);
  color: #6938ef;
}

.badge-danger-soft {
  background-color: rgba(231, 74, 59, 0.12);
  color: #e74a3b;
}

.badge-success-soft {
  background-color: rgba(28, 200, 138, 0.15);
  color: #169b6b;
}

.badge-danger-outline {
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
}

.alert-warning-soft {
  background-color: #fffbeb;
  border-left: 3px solid #f59e0b !important;
}

.patient-card {
  background-color: #f8fafc;
  border-color: #e2e8f0 !important;
}

.avatar-box {
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.avatar-img {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eef2ff;
}

.border-sm {
  border: 1px solid #eef2f6;
}

.shadow-2xs {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.custom-textarea {
  resize: none;
  font-size: 0.85rem;
}

.custom-textarea:focus {
  border-color: #bac8f3;
  box-shadow: 0 0 0 0.2rem rgba(78, 115, 223, 0.15);
}

.exams-list::-webkit-scrollbar {
  width: 4px;
}

.exams-list::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}
</style>
